{
  "longPressMessage": "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
}
